"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.input = exports.toggle = exports.root = exports.background = void 0;

var _util = require("../../../util");

const background = ({
  theme
}) => ({
  borderRadius: 7,
  width: theme.switches.toggleSize * 2.5,
  height: theme.switches.toggleSize
});

exports.background = background;

const root = ({
  theme
}) => ({
  height: theme.switches.size,
  position: 'relative',
  width: theme.switches.size * 2
});

exports.root = root;

const toggle = ({
  theme
}) => ({
  background: (0, _util.color)(theme, theme.switches.toggleBackground),
  borderRadius: '50%',
  boxShadow: (0, _util.boxShadow)(theme, theme.switches.toggleBoxShadow),
  height: theme.switches.size,
  left: 0,
  position: 'absolute',
  top: 0,
  transition: 'transform 0.2s ease',
  width: theme.switches.size
});

exports.toggle = toggle;

const input = ({
  theme
}) => ({
  appearance: 'none',
  color: 'transparent',
  cursor: 'pointer',
  height: '100%',
  margin: 0,
  position: 'absolute',
  transition: 'background 0.2s ease',
  width: '100%',
  zIndex: 2,
  ':checked ~ span:last-of-type': {
    background: (0, _util.color)(theme, theme.switches.backgroundChecked)
  },
  ':checked:disabled ~ span:last-of-type': {
    background: (0, _util.color)(theme, theme.switches.backgroundCheckedDisabled)
  },
  ':not(:checked) ~ span:last-of-type': {
    background: (0, _util.color)(theme, theme.switches.background)
  },
  ':not(:checked):disabled ~ span:last-of-type': {
    background: (0, _util.color)(theme, theme.switches.backgroundDisabled)
  },
  ':checked ~ span:not(:last-of-type)': {
    transform: 'translateX(100%)'
  }
});

exports.input = input;
//# sourceMappingURL=Switch.style.js.map